<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="push__bottom">
        <div class="grid-col grid-col--soft grid-xsmall-12 grid-large-9">
            <BackLink/>
        </div>
        <Form :data="form"
          :error="$v.form.$error"
          :formId="id"
          :formErrorMessage="errorMessage"
          @submit="submitSection">   
            <span class="caption-xl">{{subtitle}}</span>
            <Fieldset :title="title" type="heading" id="questions">
                <div :class="['form-group push__top', {'form-group--error' : $v.form.$error}]">
                    <div class="grid-row push__bottom">
                        <div class="grid-col grid-xsmall-12 grid-medium-6 grid-large-6">
                            <span><strong>{{questionLead}}</strong></span>
                        </div>                        
                        <div class="grid-col grid-xsmall-12 grid-medium-2 grid-large-2 align-center" v-for="(label, index) in questionLabels" :key="questionLabels + index"> 
                            <span class="hide--small"><strong>{{label}}</strong></span>
                        </div>
                    </div>
                    <div class="grid-row push__bottom" v-for="(q, index) in questions" :key="'q' + q.id">
                        <div class="bg__light-grey spacer push__bottom"/>
                        <div class="grid-col grid-xsmall-12 grid-medium-6 grid-large-6">
                            <span class="heading-s block soft__right push__right"><strong>{{q.question}}</strong></span>
                        </div>
                        <div class="grid-col grid-xsmall-12 grid-medium-2 grid-large-2 align-center" v-for="a in q.answers" :key="'q' + q.id + 'a' + a.id">
                            <div class="inline-block">                                              
                                <RadioButton 
                                :screenLabel="q.question + ' is '" 
                                :label="questionLabels[a.id]" 
                                :hideLabel="true" 
                                :name="'q' + q.id" 
                                :id="'q' + q.id + '-a' + a.id" 
                                :value="a.id" 
                                :model="answers[index].answer" 
                                @change="changeValue(index,a.id)"
                                />
                            </div>
                        </div>
                    </div>
                </div>

            </Fieldset>

            <div class="bg__light-grey spacer push__bottom--double"/>

            <Fieldset title="How do you feel?" type="default" id="questions">

                <div :class="['form-group', {'form-group--error' : $v.form.smilescale.$error}]">                        
                    <div class="grid-col grid-xsmall-2 grid-medium-2 grid-large-2 relative" v-for="face in smilescale" :key="face.value">
                        <div class="push__right push__bottom">
                            <label :for="'face'+face.value">
                                <span class="visually-hidden">{{face.type}} {{face.value}}</span>
                                <input class="radio__smile" :id="'face'+face.value" type="radio" name="smiley" :value="face.value" v-model="form.smilescale" @change="changeFace(face.value)">
                                <img v-if="form.smilescale == face.value" :src="publicPath + 'static/img/icons/' + face.image + '-solid.svg'" :alt="'This face is ' + face.type">
                                <img v-if="form.smilescale != face.value" :src="publicPath + 'static/img/icons/' + face.image + '-regular.svg'" :alt="'This face is ' + face.type">
                            </label>
                        </div>
                    </div>
                </div>

                <Textarea
                    id="furtherinfo"
                    name="furtherinfo"
                    label="Is there anything else about how you are feeling that you want to let us know about?"
                    errorMessage="This is a required field"
                    v-model="form.information"
                    :validate="$v.form.information"
                /> 
            </Fieldset>
    

            
        </Form>        
      </article>
    </div>
  </div>
</template>

<script>

import { required } from "vuelidate/lib/validators";
import { dataService } from "../shared";

export default {
  name: "SectionOfQuestions",
  created() {
    this.loadQuestion();
  },
  mounted() {
    this.loadAnswer();
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      id : "",
      title: "",
      content: "",
      destination: "",
      errorMessage: "All fields must be filled in",
      answers: [], 
      questions: [],
      questionLength : 0,
      smilescale: [
          {
              type: "Angry",
              image: "angry",
              value: 0
          },
          {
              type: "Not Happy",
              image: "frown",
              value: 1
          },
          {
              type: "Not Sure",
              image: "meh",
              value: 2
          },
          {
              type: "Happy",
              image: "smile",
              value: 3
          },
          {
              type: "Very Happy",
              image: "laugh",
              value: 4
          }
      ],
      form : {
          information: null,
          smilescale: null,
          questions: []
      }
    };
  },
  validations() {
      const validations = { 
        form : {
          questions: {},
          smilescale: {required},
          information: {}
        }
      };
      for (var a = 0; a < this.questionLength; a++) {
          validations.form.questions[a] = {
            answer : { required }
          }
      }
      return validations;
  },
  methods: {    
    loadQuestion() {
      let json = dataService.getQuestions();
      let questions = json.questions;
      let currentQuestion = dataService.findElement(
        questions,
        dataService.parseUrl()
      );
      this.questions = currentQuestion.questions;
      this.questionLength = currentQuestion.questions.length;
      this.id = currentQuestion.id;
      this.title = currentQuestion.title;
      this.subtitle = currentQuestion.subtitle;
      this.buttonText = currentQuestion.buttonText;
      this.questionLead = currentQuestion.questionLead;
      this.questionLabels = currentQuestion.questionLabels;
      this.destination = currentQuestion.destination;
      this.formatQuestions();
    },
    loadAnswer() {
      let previousResponse = dataService.wasAnsweredBefore(this.id);
      if (previousResponse) {
        for (var a = 0; a < this.questionLength; a++) {
          var q = previousResponse.answer[a].id;
          let radioButton = document.getElementById('q' + q + '-a' + previousResponse.answer[a].answer);
          radioButton.checked = true;
          this.changeValue(a, previousResponse.answer[a].answer);
        }
        var smileRadio = document.getElementById('face' + previousResponse.smilescale);
        smileRadio.checked = true;

        var furtherInfoBox = document.getElementById('furtherinfo');
        furtherInfoBox.value = previousResponse.furtherInfo;
      }
    },
    formatQuestions(){
      // Empty Questions Base
      for (var b = 0; b < this.questionLength; b++) {
          this.form.questions.push({
            id: this.questions[b].id,
            question: this.questions[b].question,
            answer: null
          });
      }
      // Answers List
      for (var i = 0; i < this.questionLength; i++) {
        this.answers.push({
            id: this.questions[i].id,
            question: this.questions[i].question,
            answer: null
        });
      }
      
    },
    startQuestionnaire() {        
      this.$router.push({ path: this.destination });
    },
    changeFace(newValue) {
        console.log(newValue);
        this.form.smilescale = newValue;
    },
    changeValue(index, newValue) {
        this.answers[index].answer = newValue;
        this.form.questions[index].answer = newValue;
    },
    logResponse() {
      let response = {
        id: this.id,
        questionType: "SectionOfQuestions8To10",
        answer: this.answers,
        furtherInfo: this.form.information,
        smilescale: this.form.smilescale
      };
      dataService.logResponse(response);
    },
    submitForm(form, valid) {
        valid.$touch();
        if (valid.$pending || valid.$error) {
            setTimeout(() => {
                document.querySelector(".error-summary__link").focus()
            }, 0);
            return;	
        }
        console.log(this.form.information);
        this.logResponse();
        this.$router.push({ name: this.destination.toLowerCase() });
    },
    submitSection() {
      this.submitForm(this.form, this.$v.form);
    },
    redirectToTimeout() {
      dataService.resetResponses();
      this.$router.push({ name: "timeout" });
    }
  }
};
</script>